/* eslint-disable */
import axios from 'axios'
import * as vars from '@/vars.json';

const httpAxios = axios.create({
  params: {}
});

export const restaurant = {
  namespaced: true,

  state: {
    employees: [],
    tables: [],
  },

  mutations: {
    SET_EMPLOYEES_LIST: (state, payload) => {
      state.employees = payload
    },
    SET_TABLES_LIST: (state, payload) => {
      state.tables = payload
    },
  },

  actions: {
    loadEmployees({ commit, state, rootState }, payload) {
      let userId = ''
      if(rootState.users.user.adminUid){
          userId = rootState.users.user.adminUid
      }else{
          userId = rootState.users.user.uid
      }
      firebase.database().ref(`users/${userId}/collaborators`).once('value',
          (snapshot) => {
              const res = snapshot.val()
              let arr = []
              if (res != null) {
                  Object.keys(res).forEach(employeed => {
                    if ((res[employeed].role === 'waiter' || res[employeed].role === 'chef')) {
                        if (res[employeed].shops.includes(payload)) arr.push({ id: employeed, data: res[employeed] })
                      }
                  })
              }
              commit('SET_EMPLOYEES_LIST', arr)
          }, (error) => {
              console.log(error)
          },
      )
    },
    //- Tables
    loadTables ({ commit, state, rootState }, shop) {
      let userId = ''
      if(rootState.users.user.adminUid){
        userId = rootState.users.user.adminUid
      }else{
        userId = rootState.users.user.uid
      }
      const tablesRef = firebase.database().ref(`users/${userId}/shops/${shop}/tables/`)
      tablesRef.orderByChild('created').on('value', (snapshot) => {
        let tables = []
        if (snapshot.val()) {
          snapshot.forEach(function (child) {
            tables.push({
              ...child.val(),
              id: child.key
            });
          });
        }
        commit('SET_TABLES_LIST', tables)
      }, function (error) {
        console.log(error, 'error notif')
      })
    },
    closeLoadTables ({commit, rootState}, shop) {
      let userId = ''
      if(rootState.users.user.adminUid){
        userId = rootState.users.user.adminUid
      }else{
        userId = rootState.users.user.uid
      }
      const tablesRef = firebase.database().ref(`users/${userId}/shops/${shop}/tables/`)
      tablesRef.off()
      commit('SET_TABLES_LIST', [])
    },
    addTable({ commit, state, rootState }, shop) {
      return new Promise(async (resolve, reject) => {
        let userId = ''
        if(rootState.users.user.adminUid){
          userId = rootState.users.user.adminUid
        }else{
          userId = rootState.users.user.uid
        }
        try {
          await firebase.database().ref(`users/${userId}/shops/${shop}/tables/`).push({
            created: firebase.database.ServerValue.TIMESTAMP,
            available: true
          })
          resolve('ok')
        } catch (error) {
          reject(error)
        }
      })
    },
    deleteTable({ commit, state, rootState }, payload) {
      return new Promise(async (resolve, reject) => {
        let userId = ''
        if(rootState.users.user.adminUid){
          userId = rootState.users.user.adminUid
        }else{
          userId = rootState.users.user.uid
        }
        try {
          await firebase.database().ref(`users/${userId}/shops/${payload.shop}/tables/${payload.table}`).remove()
          resolve('ok')
        } catch (error) {
          reject(error)
        }
      })
    }
  },
  getters: {
    getEmployees(state) {
      return state.employees
    },
    getTables(state){
      return state.tables
    }
  }
}
